import React from "react"
import Checkmark from "../../../../assets/checkmark.svg"
import { CommonContent } from "../../../../domain/CMS/schema"
import { AvailableDaysOfOperation } from "../../../../domain/Provider/schema"
import { Toggle } from "../../../shared/components/Toggle"
import Typography, {
  typographyTypes,
} from "../../../shared/components/Typography"

const toggleStyle = "flex flex-row no-wrap space-x-2 pr-12 pt-8 items-center"

type ProfileDaysOfOperationProps = {
  eveningsAvailableText: string
  availableDays: AvailableDaysOfOperation
  eveningsAvailable: boolean
  commonText: CommonContent
}
export const ProfileDaysOfOperation: React.FC<ProfileDaysOfOperationProps> = ({
  eveningsAvailableText,
  availableDays,
  eveningsAvailable,
  commonText,
}) => {
  // TODO: add new cms collection for this rather than taking substrings
  function getAbbreviatedDayName(i: number): React.ReactNode {
    const abbreviatedDaysOfWeek = [
      commonText.mondayAbbreviated,
      commonText.tuesdayAbbreviated,
      commonText.wednesdayAbbreviated,
      commonText.thursdayAbbreviated,
      commonText.fridayAbbreviated,
      commonText.saturdayAbbreviated,
      commonText.sundayAbbreviated,
    ]
    return abbreviatedDaysOfWeek[i]
  }

  return (
    <div>
      <div className="flex justify-start">
        {(() => {
          const dayButtonOrTags = []
          for (let i = 0; i < availableDays.length; i++) {
            const buttonOrTagStyle = availableDays[i]
              ? "border-blue-500 bg-primary-blue"
              : "border-solid border-1/4 border-gray-300 bg-transparent"
            const commonStyle =
              "flex items-center justify-center w-[72px] h-[42px] rounded-lg mr-3"
            const textStyle = availableDays[i] ? "text-white" : "gray-500"

            const buttonOrTagLabel = availableDays[i] ? (
              <div className="flex items-center">
                <img className="pr-2" src={Checkmark} alt="checkmark" />
                <div>{getAbbreviatedDayName(i)}</div>
              </div>
            ) : (
              getAbbreviatedDayName(i)
            )

            const buttonOrTag = (
              <div
                key={`available-days-of-operation-${i}-${buttonOrTagLabel}`}
                className={`${buttonOrTagStyle} ${commonStyle}`}
              >
                <Typography
                  text={buttonOrTagLabel}
                  variant={typographyTypes.LABEL}
                  styleOverrides={textStyle}
                />
              </div>
            )
            dayButtonOrTags.push(buttonOrTag)
          }
          return dayButtonOrTags
        })()}
      </div>
      <div className={`${toggleStyle}`}>
        <Toggle
          labelProps={{
            text: eveningsAvailableText,
            styleOverrides: "font-semibold text-gray-700",
          }}
          toggleState={eveningsAvailable}
          readOnly={true}
          id="provider-evenings-available-toggle"
        />
      </div>
    </div>
  )
}
